import React from "react";

export default function UserGroupsSetupNotice({
  hasManageUserGroups,
  loading,
  setupComplete,
  onCtaClick,
}) {
  if (!hasManageUserGroups || loading || setupComplete) return null;

  return (
    <div
      style={{
        background: "#f5f5f5",
        borderLeft: "3px solid #999",
        padding: "8px 10px",
        borderRadius: 3,
        fontSize: 11,
        color: "#555",
        marginBottom: 10,
        lineHeight: 1.5,
      }}
    >
      Only admin group exists. The admin group can't operate nodes. Create a
      non-admin group with operational permissions (Deploy, Provision, FW) to
      enable operational workflows.
      <div style={{ marginTop: 4 }}>
        <a
          href="#"
          style={{ color: "#25AFA8" }}
          onClick={(e) => {
            e.preventDefault();
            onCtaClick && onCtaClick();
          }}
        >
          Create user group →
        </a>
      </div>
    </div>
  );
}
